import { useMemo } from 'react';
import { useListViewNavigation } from '../../shared/useListViewNavigation';
import { MESSAGE_VIEW_ROUTES, readMessageListParams } from '../messageListParams';

export function useMessageViewNavigation() {
    const nav = useListViewNavigation(MESSAGE_VIEW_ROUTES);
    const listParams = useMemo(() => readMessageListParams(nav.searchParams), [nav.searchParams]);
    return { ...nav, listParams };
}
